import React from 'react'
import { Link } from 'react-router-dom'

import './QbLink.css'

const QbLink = ({ to, name, regular, style }) => {
  return (
    <Link style={style} className={getLinkClasses(regular)} to={to}>{name}</Link>
  )
}

export default QbLink

export const QbOutsideLink = ({ to, name, regular, big, children, style }) => (
  <a style={style} target="_blank" href={to} className={getOutsideLinkClasses(regular, big)}>{name || children}</a>
)

function getOutsideLinkClasses(regular, big) {
  return `qb-link ${big ? 'qb-link--big' : ''} ${regular ? 'qb-link--regular' : ''}`
}

function getLinkClasses(regular) {
  return `qb-link qb-link--big ${regular ? 'qb-link--regular' : ''}`
}


// WEBPACK FOOTER //
// ./src/components/shared/QbLink/QbLink.js